import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const VATManagerService = {};

// List User
VATManagerService.listVATManager = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // sort: params.sort || "-maker_date",
      // keywords: params.keywords || "",
      // expand: params.expand || "usprofile,checker",
    },
  });
};

// List User Role
VATManagerService.listUserRole = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/users/default-roles`,
    method: "get",
    params: { ...params },
  });
};

// Create User
VATManagerService.createVATManager = ({ userCreate }) => {
  return fetch({
    url: `${env.API_MSP}/vats`,
    method: "post",
    data: {
      ...userCreate,
    },
  });
};
// Update
VATManagerService.updateVATManager = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/vats/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Detail User
VATManagerService.detailVATManager = function ({ userId, params }) {
  return fetch({
    url: `${env.API_MSP}/vats/${userId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "usprofile",
    },
  });
};

// Update User
VATManagerService.updateUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete User
VATManagerService.deleteVATManager = ({ userId }) => {
  return fetch({
    url: `${env.API_MSP}/vats/${userId.userId}`,
    method: "delete",
  });
};

// Active User
VATManagerService.activeUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}/restore`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default VATManagerService;
